import axios from 'axios';

export default class RetailerDocuments {
  static init(...parameters) {
    return new RetailerDocuments(...parameters);
  }

  constructor(container) {
    if (container) {
      this.logOffButton = container.querySelector('.log-off-button');

      if (this.logOffButton) {
        this.logOffButton.addEventListener('click', this.logOff);
      }
    }
  }


  logOff() {
    const button = document.querySelector('.log-off-button');
    button.classList.add('-loading');
    const login = document.querySelector('.log-in');
    const logout = document.querySelector('.log-out');
    const overlay = document.querySelector('.login-overlay');
    const endpointUrl = document.querySelector('input[name="logOff_endpoint"]').value;
    axios.get(endpointUrl)
      .then((response) => {
        if (response.status === 200) {
          if (login && logout) {
            login.classList.add('-hidden');
            logout.classList.remove('-hidden');
            overlay.classList.add('-visible');
            overlay.classList.remove('-hidden');
            button.classList.remove('-loading');
            setTimeout(() => {
              login.classList.remove('-hidden');
              logout.classList.add('-hidden');
              overlay.classList.remove('-visible');
              overlay.classList.add('-hidden');
              window.location.href = document.location.origin;
            }, 2000);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        button.classList.remove('-loading');
      });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-retailer-documents', RetailerDocuments.init);
}
